import React, {useEffect, useRef, useState} from "react"
import {Button, Divider, Form, Input, message, Modal} from "antd";
import '../../login/components/Login.css'
import { useNavigate} from "react-router-dom";
import type {SubmitCredentialsRequestModel} from "../../login/models/SubmitCredentialsRequestModel";
import {
    CloseCircleFilled,
    ExclamationCircleFilled,
} from "@ant-design/icons";
import {submitCredentialsRequest} from "../../login/service/LoginService";
import ModalContent from "../../../constant/ModalContent";
import Indicator from "../../common/components/Indicator";
import Header from "../../../components/header/Header";


export default function SubscriptionLogin(){

    const [nicNumber,setNicNumber]= useState("");
    const [visible, setVisible] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [isLoading,setIsLoading] = useState(false);
    const [random,setRandom]=useState(0);
    // const [logMessage, setLogMessage] = useState(LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE);

    const carrierPostData = localStorage.getItem("carrierPostData");
    const status= localStorage.getItem("status");
    const mobileNumber=localStorage.getItem("msisdn");

    // const isMountedRef = useRef(false);

    const [form] = Form.useForm();

    const getUniqueId = () => {
        const min = 0;
        const max = 100;
        const rand = Math.floor(Math.random() * (max - min + 1) + min);
        console.log(rand);
        setRandom(rand);
        console.log(random);
        return rand;
    };

    const navigate=useNavigate();

    const handleCancel = () => {
        setVisible(false);
        // setLogMessage(LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE);
        // isMountedRef.current = false;
    };

    const handleCancelWithCallback = () => {
        // eslint-disable-next-line no-undef
        DataActivationController.doneSelected()
        setVisible(false);
        // setLogMessage(LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE);
        // isMountedRef.current = false;
    };

    const handleSubmit=async (values)=>{
        setIsLoading(true);
        try{
            const submitCredentialsRequestModel:SubmitCredentialsRequestModel={
                "request-id":getUniqueId(),
                carrierPostData: carrierPostData,
                msisdn: values.mobileNumber,
                password: values.nicNumber,
                signUpFlag: status=== "SIGNUP"?true:false,
                transferFlag: false,
                channel: "ws"
            };

            const response = await submitCredentialsRequest(submitCredentialsRequestModel);
            setIsLoading(false);
            console.log(response);
            console.log(submitCredentialsRequestModel.carrierPostData);
            if(response.resultCode===6000){
                navigate("/manage-subscription/device-list");
            }else if(response.resultCode===6400){
                setModalContent(
                    <>
                        <CloseCircleFilled />
                        <h3>Invalid ID number</h3>
                        <div>
                            {ModalContent.INVALID_ID_NUMBER_MESSAGE}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancel}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Invalid ID number").replace("{{page}}", LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE));
                // isMountedRef.current = false;
            }else if(response.resultCode===6401){
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Not eligible for Apple Watch one number service</h3>
                        <div>
                            {ModalContent.NOT_ELIGIBLE_MESSAGE}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Not eligible for Apple Watch one number service").replace("{{page}}", LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE));
                // isMountedRef.current = false;
            } else if(response.resultCode===6402){
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Error Occurred!</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Error Occurred").replace("{{page}}", LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE));
                // isMountedRef.current = false;
            }else if(response.resultCode === 6403) {
                message.error(response.resultDesc, 1)
                navigate("/")
            }else if(response.resultCode === 6405) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Maximum Device Count Reached</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Maximum Device Count Reached").replace("{{page}}", LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE));
                // isMountedRef.current = false;
            }else if(response.resultCode === 6406) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled/>
                        <h3>Your account is blocked.</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Account Blocked").replace("{{page}}", LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE));
                // isMountedRef.current = false;
            }
        }catch (error){
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION,1);
            throw new Error(error);
        }
    }

    useEffect(() => {

        // if (!isMountedRef.current) {
        //     isMountedRef.current = true;
        //     const payload = {
        //         level: "INFO",
        //         timestamp: new Date().toISOString(),
        //         pageName: LogContent.MANAGE_SUBSCRIPTION_LOGIN_PAGE,
        //         message: logMessage
        //     };
        //
        //     submitWebSheetLogCollection(payload)
        //         .then(() => {
        //             console.log('Log submitted successfully');
        //         })
        //         .catch(error => {
        //             console.error('Error submitting log:', error);
        //         });
        // }

    }, []);

    return (
        <div>
                <div style={{backgroundColor:"#E6E6E6",width:"100%"}}>
                    <Header/>
                </div>

                {isLoading && <Indicator />}

                <Form
                    className="form"
                    onFinish={handleSubmit}
                    name="form"
                >
                    <p className="para-title">
                        Activate and manage the wireless service on your Apple Watch
                    </p>

                    <Form.Item
                        name="mobileNumber"
                        initialValue={mobileNumber}
                    >
                        <Input
                            placeholder="Mobile number"
                            disabled={true}
                               // value={mobileNumber}
                        />
                    </Form.Item>
                    <Form.Item
                        name="nicNumber"
                        rules={[
                            {
                                required: true,
                                message: "Please enter the NIC /Passport /Driving Licence Number"
                            },
                            {
                                pattern: /^[A-Za-z0-9]{8,12}$/,
                                message: "Enter a valid NIC /Passport /Driving Licence Number"
                            }
                        ]}
                    >
                        <Input
                            placeholder="NIC number"
                            value={nicNumber}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            className="mainButton"
                            type="primary"
                            shape="round"
                            htmlType="submit"
                            style={{ backgroundColor: "#f13434"}}
                            disabled={isLoading}
                        >
                            LOGIN
                        </Button>
                    </Form.Item>

                </Form>
            <Modal
                open={visible}
                onCancel={handleCancel}
                footer={null}
                closable={false}
            >
                {modalContent}
            </Modal>
        </div>
    )

}